module.exports = __webpack_public_path__ + "img/ING_icon.ceb9621c.png";